import React from 'react';
import { withNotifications } from '../notifications/NotificationsContext';

class MarketingCopy extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.onDisclosureClick = this.onDisclosureClick.bind(this);
  }

  getDisclosureElements() {
    return Array.prototype.slice.call(
      this.ref.current.querySelectorAll('a[disclosure]')
    );
  }

  onDisclosureClick(event) {
    const { notifications } = this.props;
    const id = event.currentTarget.getAttribute('disclosure');
    notifications.showById(id, event);
  }

  componentDidMount() {
    this.getDisclosureElements().forEach(el => {
      el.addEventListener('click', this.onDisclosureClick);
    });
  }

  componentWillUnmount() {
    this.getDisclosureElements().forEach(el => {
      el.removeEventListener('click', this.onDisclosureClick);
    });
  }

  render() {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: this.props.content }}
        ref={this.ref}
        className={this.props.className || ''}
      />
    );
  }
}

export default withNotifications(MarketingCopy);
